export default [
    {
        path: 'user-info',
        component: () => import('@/pages/isle/dash/user-info')
    },
    {
        path: 'server-info',
        component: () => import('@/pages/isle/dash/server-info')
    }
];